module.exports = __webpack_public_path__ + "img/Reorganiza_Logo-2.e1be0277.png";